
























































































































import Vue from 'vue';
import { mapState, mapActions } from 'vuex';

const VueTelInput = () => Promise.all([
    // @ts-ignore
    import('vue-tel-input'),
    // @ts-ignore
    import('vue-tel-input/dist/vue-tel-input.css'),

]).then(([{ VueTelInput }]) => VueTelInput);

Vue.use(VueTelInput);

export default Vue.extend({
    props: {
        formDataToEdit: {
            type: Object,
            default: () => ({} as any),
        },
        value: {
            type: Boolean,
            default: false,
        },
        formMode: {
            type: String,
        },
        title: {
            type: String,
        },
    },
    components: {
        VueTelInput,
    },

    data() {
        return {
            isPendingUser: false,
            loading: false,
            valid: true,
            isFormValid: false,
            formData: {} as any,
            options: { type: 'tel' },
            telProps:
            {
                defaultCountry: 'US',
                preferredCountries: ['US', 'GB'],
                validCharactersOnly: true,
                autocomplete: 'off',
                ignoredCountries: ['IR', 'KP', 'SY', 'CU', 'VE'],
                dropdownOptions: {
                    showFlags: true,
                    showDialCodeInSelection: true,
                    showDialCodeInList: true,
                    showSearchBox: true,
                    width: '290px',
                },
                inputOptions: {
                    placeholder: 'Mobile Number',
                    type: 'tel',
                },
            },
        };
    },
    watch: {
        value(isVisible) {
            if (isVisible) {
                this.isPendingUser = this.formDataToEdit.status === 'pending';
                this.formData = this.formMode === 'edit'
                    ? {
                        officeId: this.formDataToEdit.corpOfficeId,
                        group: this.formDataToEdit.group,
                        email: this.formDataToEdit.email,
                        phoneNumber: this.formDataToEdit?.phone,
                        phoneCountryCode: this.formDataToEdit.countryCode ?? '1',
                        name: this.formDataToEdit.fullName,
                        corpUserId: this.formDataToEdit.corpUserId,
                        suspend: this.formDataToEdit.isSuspended,
                        verifiedEmail: this.formDataToEdit.isEmailVerified,
                    }
                    : {
                        officeId: null,
                        group: 'regular',
                        email: null,
                        phoneNumber: null,
                        phoneCountryCode: '1',
                        name: null,
                    };
            }
        },
    },
    computed: {
        ...mapState('offices', ['corpOffices']),
        ...mapState('employees', ['employees']),
    },
    methods: {
        ...mapActions('employees', ['getEmployees']),
        ...mapActions('offices', ['getOffices']),

        countryChanged(country: any) {
            this.formData.phoneCountryCode = country.dialCode;
        },
        isPhoneValide(inputObject: any) {
            if (inputObject.valid) {
                this.isFormValid = true;
                this.formData.phoneCountryCode = inputObject.countryCallingCode;
                this.formData.phoneNumber = inputObject.nationalNumber;
            } else {
                this.isFormValid = false;
            }
        },
        async saveForm() {
            if (!this.formData.email && !this.formData.phoneNumber) {
                this.$notifier.showError('Email or phone is required');
                return;
            }
            // @ts-ignore
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true;
                    if (!this.formData.phoneNumber) {
                        this.formData.phoneCountryCode = null;
                        this.formData.phoneNumber = null;
                    }
                    if (!this.formData.email) {
                        this.formData.email = null;
                    }
                    if (this.formMode === 'edit') {
                        const res = await this.$hipApi.editUser(this.formData.corpUserId, this.formData);
                        this.$notifier.showSuccess('Successfully updated');
                    } else {
                        const res = await this.$hipApi.addUser(this.formData);
                        this.$notifier.showSuccess('Successfully created an employee');
                    }
                    this.closeForm();
                    this.getEmployees();
                } catch (err) {
                    if (err?.error?.message === 'User mail or phone already exists') {
                        const employeesMails = this.employees.map((employee: any) => employee.email || null).filter((rec: any) => rec != null);
                        const employeesPhones = this.employees
                            .map((employee: any) => (employee.countryCode && employee.phone ? `${employee.countryCode} ${employee.phone}` : null))
                            .filter((rec: any) => rec != null);
                        if (employeesMails.includes(this.formData.email) || employeesPhones.includes(`${this.formData.phoneCountryCode} ${this.formData.phoneNumber}`)) {
                            this.$notifier.showInfo("Employee's mail or phone already registered");
                        } else {
                            this.$notifier.showInfo(
                                `This e-mail or phone already exists on a HQ Shuttles account that is not associated with your company.
                                <br>Are you sure you want to add this account to your corporate shuttle service?`,
                                async () => {
                                    try {
                                        await this.$hipApi.addRegisteredUser(this.formData);
                                        this.$notifier.showSuccess('Successfully created an employee');
                                        this.closeForm();
                                        this.getEmployees();
                                    } catch (err) {
                                        this.$notifier.showError(err?.error?.message || err?.message || err);
                                    }
                                },
                            );
                        }
                    } else {
                        this.$notifier.showError(err?.error?.message || err?.message || err);
                    }
                }
                this.loading = false;
            }
        },
        closeForm() {
            this.$emit('input', false);
            // @ts-ignore
            this.$refs.form.reset();
        },
    },
    created() {
        this.getOffices();
    },
});
